import React from "react";

// Skip to main content link for keyboard/screen reader users
const SkipLink = () => (
  <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[9999] focus:bg-[#63b32e] focus:text-white focus:px-4 focus:py-2 focus:rounded-lg focus:text-sm focus:font-semibold focus:shadow-lg">
    Zum Hauptinhalt springen
  </a>
);
export default SkipLink;
